import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Zap, Layers, ShieldCheck, Lock, CreditCard } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden" data-id="element-142">
      {/* Background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-amber-500/20 blur-[120px] rounded-full pointer-events-none" data-id="element-143" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500/10 border border-amber-500/20 text-amber-400 font-bold text-sm mb-8" data-id="element-145">
          <span data-id="element-146">💛</span> NUEVO NIVEL™
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        delay: 0.15,
        type: 'spring',
        stiffness: 120
      }} className="mb-10 flex justify-center" data-id="element-147">
          <img src="https://cdn.magicpatterns.com/uploads/5DWC4kHTaLh3L15wkBq7mw/heylloyd-image-1781763631676.png" alt="Combo Nuevo Nivel TDAH — libro completo, guías y bonos para padres" className="w-full max-w-md md:max-w-lg aspect-square object-cover rounded-2xl drop-shadow-[0_20px_60px_rgba(251,191,36,0.25)]" data-id="element-148" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-4xl md:text-6xl lg:text-7xl font-black text-white leading-tight mb-6" data-id="element-149">
          Todo lo que necesitás para{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-300 to-amber-500" data-id="element-150">
            acompañar a tu hijo.
          </span>
          <br data-id="element-151" />
          <span className="text-3xl md:text-5xl text-slate-300 mt-2 block" data-id="element-152">
            Listo. Desde hoy.
          </span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="bg-slate-800/50 border border-slate-700/50 rounded-2xl p-6 md:p-8 mb-10 backdrop-blur-sm" data-id="element-153">
          <h2 className="text-xl md:text-2xl font-bold text-amber-400 mb-4 tracking-wide" data-id="element-154">
            COMBO COMPLETO TDAH — PADRES QUE ACOMPAÑAN
          </h2>
          <p className="text-lg md:text-xl text-slate-300 font-medium mb-4" data-id="element-155">
            El sistema N°1 de apoyo para padres de niños con TDAH
          </p>
          <p className="text-slate-400 max-w-2xl mx-auto" data-id="element-156">
            Información + herramientas + estrategias listas para usar. Sin
            improvisar. Sin agotarte. Sin perder más tiempo buscando respuestas
            sueltas en internet.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="flex flex-wrap justify-center gap-4 mb-10" data-id="element-157">
          <div className="flex items-center gap-2 bg-slate-900 px-4 py-2 rounded-lg border border-slate-800 text-sm font-semibold text-slate-300" data-id="element-158">
            <FileText className="w-4 h-4 text-amber-400" data-id="element-159" /> 100% PDF
          </div>
          <div className="flex items-center gap-2 bg-slate-900 px-4 py-2 rounded-lg border border-slate-800 text-sm font-semibold text-slate-300" data-id="element-160">
            <Zap className="w-4 h-4 text-amber-400" data-id="element-161" /> Acceso en 5 min
          </div>
          <div className="flex items-center gap-2 bg-slate-900 px-4 py-2 rounded-lg border border-slate-800 text-sm font-semibold text-slate-300" data-id="element-162">
            <Layers className="w-4 h-4 text-amber-400" data-id="element-163" /> Todos los niveles
          </div>
        </motion.div>

        <motion.button initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4,
        type: 'spring',
        stiffness: 200
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} onClick={scrollToPricing} className="w-full md:w-auto text-center bg-gradient-to-r from-amber-400 to-amber-500 text-slate-950 text-xl md:text-2xl font-black py-5 px-10 rounded-full shadow-[0_0_40px_rgba(251,191,36,0.4)] hover:shadow-[0_0_60px_rgba(251,191,36,0.6)] transition-all mb-8 flex items-center justify-center gap-3 mx-auto" data-id="element-164">
          💛 → QUIERO MI COMBO AHORA
        </motion.button>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="flex flex-wrap justify-center items-center gap-6 text-sm text-slate-400 font-medium" data-id="element-165">
          <span className="flex items-center gap-1.5" data-id="element-166">
            <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-167" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-168">
            <Lock className="w-4 h-4 text-green-400" data-id="element-169" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-170">
            <CreditCard className="w-4 h-4 text-blue-400" data-id="element-171" /> Mercado Pago
          </span>
        </motion.div>
      </div>
    </section>;
}